export const API_URL = 'https://api.educatetheworld.co.uk';

